import { Link } from "react-router-dom";
import type { MemeItem } from "@/mocks/memes";

interface MemeCardProps {
  item: MemeItem;
  rank?: number;
}

export default function MemeCard({ item, rank }: MemeCardProps) {
  const hotText = item.hot >= 1000 ? `${(item.hot / 1000).toFixed(1)}k` : `${item.hot}`;

  return (
    <Link
      to={`/meme/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-100" style={{ aspectRatio: "4 / 3" }}>
        <img
          src={item.cover}
          alt={`${item.title} - ${item.categoryName}素材`}
          title={`${item.title} · 131吃瓜梗图`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
        />
        <span className="absolute left-3 top-3 rounded-full bg-primary-500/95 px-2.5 py-1 text-xs text-background-50">
          {item.categoryName}
        </span>
        {typeof rank === "number" && (
          <span className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-secondary-500 text-xs font-bold text-primary-950">
            {rank}
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col gap-3 p-4">
        <h3 className="font-heading text-base leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>

        <div className="mt-auto flex flex-wrap gap-2">
          {item.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900"
            >
              #{tag}
            </span>
          ))}
        </div>

        <div className="flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500"></i>
            热度 {hotText}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-download-2-line text-accent-600"></i>
            {item.downloads} 次保存
          </span>
        </div>
      </div>
    </Link>
  );
}